module.exports = __webpack_public_path__ + "static/media/storyboard.d9f67763.png";